import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'reason-for-consultation',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'reason-for-consultation-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.reason-for-consultation-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "reason-for-consultation-index" */ '@/modules/configurations/catalogs/reason-for-consultation/views/Index.vue')
        },
        {
            path: 'create',
            name: 'reason-for-consultation-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'reason-for-consultation-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.reason-for-consultation-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.reason-for-consultation-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "reason-for-consultation-create" */ '@/modules/configurations/catalogs/reason-for-consultation/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'reason-for-consultation-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'reason-for-consultation-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.reason-for-consultation-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.reason-for-consultation-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "reason-for-consultation-edit" */ '@/modules/configurations/catalogs/reason-for-consultation/views/Edit.vue')
        }
    ]
}